import { useCallback, useContext } from 'react';
import type { FunctionComponent } from 'react';

import { Button, ModalsWrapperContext } from '@kanda-libs/ks-design-library';

import EditLenderConfigModal from './EditLenderConfigModal';
import { MODAL_ID } from './constants';

const EditLenderConfig: FunctionComponent = function () {
  const { showModal } = useContext(ModalsWrapperContext);
  const onClick = useCallback(() => showModal(MODAL_ID), [showModal]);

  return (
    <>
      <Button.Text
        id="staff-edit-lender-config"
        label="Edit lender configs"
        onClick={onClick}
        variant="solid"
        size={40}
      />
      <EditLenderConfigModal />
    </>
  );
};

export default EditLenderConfig;
